setTimeout(() => {
  var ya = new Swiper(".sm-hide-slider .gallery-swiper-thumbs", {
    slidesPerView: 5,
    loop: !1,
    spaceBetween: 3,
    watchSlidesProgress: !0,
    touchRatio: .4
  });
  var swip = new Swiper(".sm-hide-slider .gallery-swiper", {
    slidesPerView: 1,
    loop: !0,
    thumbs: {swiper:ya} 
  });
  
  // variant radio change to change image
  var variantRadioButtons = document.querySelectorAll('.section-main-products .variantRadioButton');
  if (variantRadioButtons) {
    variantRadioButtons.forEach(function (radioButton) {
      radioButton.addEventListener('click', function () {
        const radioDataIndex = radioButton.getAttribute('data-index');
        updateSwiperSlide(radioDataIndex);
      });
    });
  
    function updateSwiperSlide(variantIndex) {
      var mediaItems = document.querySelectorAll('.section-main-products .product__media-item');
    
      mediaItems.forEach(function (mediaItem) {
        var altMedia = mediaItem.getAttribute('data-media-attr');
        if (altMedia == variantIndex) {
          var swiperSlideIndex = mediaItem.getAttribute('data-swiper-slide-index');
          swip.slideTo(swiperSlideIndex);
        }
      });
    }
  }
}, "700");

/*
var variantRadioButtons = document.querySelectorAll('.section-main-products .variantRadioButton');
if (variantRadioButtons) {
  variantRadioButtons.forEach(function (radioButton) {
    radioButton.addEventListener('change', function () {
      const radioDataIndex = radioButton.getAttribute('data-index');
      updateSwiperSlide(radioDataIndex);

      var vals = document.querySelector(".loop-widget-purchase-option-selected .loop-widget-purchase-option-label").textContent;
      console.log(vals);

      
    });
  });

  function updateSwiperSlide(variantIndex) {
    var mediaItems = document.querySelectorAll('.section-main-products .product__media-item');
  
    mediaItems.forEach(function (mediaItem) {
      var altMedia = mediaItem.getAttribute('data-media-attr');
      console.log(altMedia, variantIndex)
      if (altMedia == variantIndex) {
        var swiperSlideIndex = mediaItem.getAttribute('data-swiper-slide-index');
        inv_product_slider.slideTo(swiperSlideIndex);
      }
    });
  }
}
*/

(()=>{var e={539:()=>{},5072:e=>{"use strict";var t=[];function r(e){for(var r=-1,n=0;n<t.length;n++)if(t[n].identifier===e){r=n;break}return r}function n(e,n){for(var a={},c=[],i=0;i<e.length;i++){var s=e[i],u=n.base?s[0]+n.base:s[0],l=a[u]||0,d="".concat(u," ").concat(l);a[u]=l+1;var v=r(d),f={css:s[1],media:s[2],sourceMap:s[3],supports:s[4],layer:s[5]};if(-1!==v)t[v].references++,t[v].updater(f);else{var p=o(f,n);n.byIndex=i,t.splice(i,0,{identifier:d,updater:p,references:1})}c.push(d)}return c}function o(e,t){var r=t.domAPI(t);r.update(e);return function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap&&t.supports===e.supports&&t.layer===e.layer)return;r.update(e=t)}else r.remove()}}e.exports=function(e,o){var a=n(e=e||[],o=o||{});return function(e){e=e||[];for(var c=0;c<a.length;c++){var i=r(a[c]);t[i].references--}for(var s=n(e,o),u=0;u<a.length;u++){var l=r(a[u]);0===t[l].references&&(t[l].updater(),t.splice(l,1))}a=s}}},7659:e=>{"use strict";var t={};e.exports=function(e,r){var n=function(e){if(void 0===t[e]){var r=document.querySelector(e);if(window.HTMLIFrameElement&&r instanceof window.HTMLIFrameElement)try{r=r.contentDocument.head}catch(e){r=null}t[e]=r}return t[e]}(e);if(!n)throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");n.appendChild(r)}},540:e=>{"use strict";e.exports=function(e){var t=document.createElement("style");return e.setAttributes(t,e.attributes),e.insert(t,e.options),t}},5056:(e,t,r)=>{"use strict";e.exports=function(e){var t=r.nc;t&&e.setAttribute("nonce",t)}},7825:e=>{"use strict";e.exports=function(e){var t=e.insertStyleElement(e);return{update:function(r){!function(e,t,r){var n="";r.supports&&(n+="@supports (".concat(r.supports,") {")),r.media&&(n+="@media ".concat(r.media," {"));var o=void 0!==r.layer;o&&(n+="@layer".concat(r.layer.length>0?" ".concat(r.layer):""," {")),n+=r.css,o&&(n+="}"),r.media&&(n+="}"),r.supports&&(n+="}");var a=r.sourceMap;a&&"undefined"!=typeof btoa&&(n+="\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(a))))," */")),t.styleTagTransform(n,e,t.options)}(t,e,r)},remove:function(){!function(e){if(null===e.parentNode)return!1;e.parentNode.removeChild(e)}(t)}}}},1113:e=>{"use strict";e.exports=function(e,t){if(t.styleSheet)t.styleSheet.cssText=e;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(e))}}}},t={};function r(n){var o=t[n];if(void 0!==o)return o.exports;var a=t[n]={exports:{}};return e[n](a,a.exports,r),a.exports}r.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return r.d(t,{a:t}),t},r.d=(e,t)=>{for(var n in t)r.o(t,n)&&!r.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},r.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),r.nc=void 0,(()=>{"use strict";var e=r(5072),t=r.n(e),n=r(7825),o=r.n(n),a=r(7659),c=r.n(a),i=r(5056),s=r.n(i),u=r(540),l=r.n(u),d=r(1113),v=r.n(d),f=r(539),p=r.n(f),m={};m.styleTagTransform=v(),m.setAttributes=s(),m.insert=c().bind(null,"head"),m.domAPI=o(),m.insertStyleElement=l();t()(p(),m);p()&&p().locals&&p().locals;(document.addEventListener("DOMContentLoaded",(function(){var e=document.querySelectorAll(".b-buy-box__tab"),t=document.querySelectorAll(".b-buy-box__tab-panel"),r=document.querySelector("body"),n=document.querySelector(".b-header__wrapper");e.forEach((function(r){r.addEventListener("click",(function(){e.forEach((function(e){e.classList.remove("active")})),t.forEach((function(e){e.classList.remove("active")}));var n=parseInt(r.getAttribute("data-tab"));r.classList.add("active"),t[n-1].classList.add("active")}))}));var o=document.querySelectorAll(".video-image"),a=document.querySelectorAll(".video"),c=a.length,i=0,s=document.querySelector(".video-modal");function u(e){a.forEach((function(e){var t=e.querySelector("video");e.classList.remove("active"),t.pause()})),a[e].classList.add("active"),i=e,a[e].querySelector("video").play()}o.forEach((function(e,t){e.addEventListener("click",(function(){u(t),s.classList.add("active"),r.classList.add("no-scroll"),n.style.zIndex=2}))})),a.forEach((function(e){e.addEventListener("click",(function(){var t=e.querySelector("video");t.paused?t.play():t.pause()}))}));var l=document.querySelector(".video-button-next"),d=document.querySelector(".video-button-prev"),v=document.querySelectorAll(".video-modal-close");l&&l.addEventListener("click",(function(){u(i=(i+1)%c)})),d&&d.addEventListener("click",(function(){u(i=(i-1+c)%c)})),v&&v.forEach((function(e){e.addEventListener("click",(function(){s.classList.remove("active"),r.classList.remove("no-scroll"),n.style.zIndex=14,a.forEach((function(e){var t=e.querySelector("video");e.classList.remove("active"),t.pause()}))}))}));var f=document.querySelectorAll(".js-variant-select");f.forEach((function(e){e.addEventListener("click",(function(){f.forEach((function(e){e.classList.remove("active")})),this.classList.add("active")/*,document.querySelector(".b-buy-box__variants-wrapper h4 span").textContent=this.textContent*/}))}))})),document.querySelectorAll(".gallery-thumb").length<2)&&document.querySelector(".gallery-swiper-thumbs").remove();})()})();

/*if (window.innerWidth < 768) {*/
  /*var ya = new Swiper(".sm-hide-slider .gallery-swiper-thumbs", {
    slidesPerView: 5,
    loop: !1,
    spaceBetween: 3,
    watchSlidesProgress: !0,
    touchRatio: .4
  });
  var swip = new Swiper(".sm-hide-slider .gallery-swiper", {
    slidesPerView: 1,
    loop: !0,
    thumbs: {swiper:ya} 
  });*/
/*}

window.onresize = function(event) {
  if (window.innerWidth < 768) {
    var y=new Swiper(".gallery-swiper-thumbs", {
      slidesPerView: 5,
      loop: !1,
      spaceBetween: 8,
      watchSlidesProgress: !0,
      touchRatio: .4
    });
    new Swiper(".gallery-swiper", {
      slidesPerView: 1,
      loop: !0,
      thumbs: {swiper:y} 
    })
  }
};
*/